<template>
  <div style="width:100%" class="p-3">  
    <b-row>     
      <b-col  class="p-0">
         <b-input-group
          size="sm"
          class="mb-3 sw-search"
          prepend="Buscar"
        >
          <b-form-input  :autofocus="saveConfig.autofocus" v-model="currentSearch" placeholder="Escribe aquí para filtrar los resultados"></b-form-input>
            <b-input-group-append>
              <b-button size="sm" 
            style="background:#e9ecef;color:#495057;border: 1px solid #ced4da;" text="Button" variant="info">txt</b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button size="sm" 
            style="background:#e9ecef;color:#495057;border: 1px solid #ced4da;" text="Button" variant="secondary">Pdf</b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button size="sm" 
            style="background:#e9ecef;color:#495057;border: 1px solid #ced4da;" text="Button" variant="success" class="search-radius">Excell</b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
    </b-row>
      <table style="margin-bottom:0" class="table table--get table-hover border box-effect linear table-sm table-bordered sw-table-dark">
        <thead  class="table-dark ">         
          <tr>
            <th v-for="(items,index) in tableItems" :key="'thtableGet'+index"> 
                {{items.thead.th}}         
                <span @click="items.thead.sort=sort(items.thead.sort,items.thead.sortTable,index)" class="sw-sort" v-if="items.thead.sort!==undefined" :class="{'sw-sortdown': items.thead.sort===false, 'sw-sortup': items.thead.sort===true}"></span>
            </th>
            <th class="text-right"  v-if="tableOptions!=='' && typeof tableOptions === 'object'">              
                  Opciones 
            </th>
          </tr>
        </thead>
        <tbody class="tabletableinput"  style="background: white">
          <tr>            
          </tr>
          <tr v-for="(items,index) in sortedTable()" :key="'dataGetTabletable'+index">
            <td v-for="(items2,index2) in tableItems" :key="'tdGet'+index2"> 
              <div v-if="!items2.tbody.input">
                <div v-if="!items2.tbody.link" >
                  <span   v-for="(items4,index4) in items2.tbody.td" :key="'inputstable'+index4">
                    <span v-if="items2.tbody.checks">
                      <span v-if="items[items4]===true">
                        {{items2.tbody.checks[index4]}}  
                      </span>                  
                    </span>
                    <span v-else>
                      <span v-if="items4.includes('text/')">
                          {{items4.replace('text/','')}}
                      </span>
                      <span v-else>
                        {{items[items4]}} 
                      </span>                                       
                    </span>
                  </span>  
                </div>  
                <div v-else>
                    <b-button variant="white" size="sm" @click="openLinks(items2.tbody.link,items[items2.tbody.td[0]])" class="btn-link">Pdf</b-button>
                </div>                              
              </div>
              <div v-if="items2.tbody.input">
                  <sw-inputstabletable
                    v-for="(items4,index4) in items2.tbody.td" :key="'inputstable'+index4"
                    :inputTabla="tabla"
                    :inputCampo="items4"
                    :index="items.index"
                    :indexIndex="tableIndex"
                    >
                  </sw-inputstabletable>
              </div>
            </td> 
            <td class="text-right" v-if="tableOptions!=='' && typeof tableOptions === 'object'">
                <div style="display:inline-block;padding-left:5px;padding-right:5px" v-for="(items2,index2) in tableOptions" :key="'optionsTables'+index2">
                  <b-icon :id="'optionsTableguardar'+index" class="option-btn" :icon="items2.icon" scale="1.7" :variant="items2.variant"></b-icon>
                  <b-popover
                    :target="'optionsTableguardar'+index"
                    placement="bottom"
                    :title="items2.msj"
                    triggers="hover"
                  >
                    <template v-slot:default>
                      <div class="text-center mt-3">
                        <sw-inputs
                          class="text-left"
                          v-for="(items3,index3) in items2.inputs" :key="'inputs'+index2+index3"
                          :inputTabla="inputData(items3).table"
                          :inputCampo="inputData(items3).campo"
                          :lg="12"
                          :md="12"
                        ></sw-inputs>
                        <b-button 
                          v-if="!saveConfig.capa" 
                          size="sm" 
                          @click="save(items2.ftn,items,items2.inputs)" :variant="items2.variant">                            
                          {{items2.btn}}
                        </b-button>
                        <b-button  
                          v-if="saveConfig.capa" 
                          disabled 
                          :variant="items2.variant"
                          size="sm" 
                          class="ml-2 sw-save-loading" 
                          ><div> <b-spinner variant="light" label="Spinning"></b-spinner></div>{{items2.btn}}</b-button>
                      </div>
                    </template>                  
                  </b-popover>
                </div>                 
            </td>
          </tr>
        </tbody>
      </table>       
      <b-row v-if="sortedTable().length>10">    
        <b-col md="3" class="p-0">
          <b-pagination style="margin-bottom:0" class="paginatable" v-model="pagination" :total-rows="rows" size="sm" first-number  align="fill"></b-pagination>
        </b-col> 
        <b-col  class="p-0">
        </b-col>
      </b-row>
  </div>
</template>
<script>
import SwInputs from '@/components/forms/inputs.vue'
import SwInputstabletable from '@/components/forms/inputsTabletable.vue'
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';
function cleanParameter(value)
  {
    if(value==null)
    {
      return '';
    }
    return value.toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
  }
export default 
{
  name: 'swTableget',
  components: { SwInputstabletable,SwInputs  },
  props: {
    tableSearch: {
      type: Array,
      default: function()
      {
        return []
      }
    },
    tableItems: {
      type: Array,
      default: function()
      {
        return []
      }
    },
    tableOptions: {
      default: function()
      {
        return ''
      }
    },
    name: {
      type: String,
      default: ''
    },
    tabla: {
      type: String,
      default: ''
    },
    tableIndex: {
      type: Number,
      default: 0
    },
  },
  data () {
    return {
      currentSearch:'',
      currentSort:'id',
      currentSortDir: '', 
      pagination: 1,
      rows: 100    
    }
  },
  methods: {      
    openLinks(link,id)
    {
      window.open( this.url+link+'?id='+id+'&token='+this.token,'_blank')
    },
    async save(btn,data,inputs)
    {  
      let splits 
      let dataForm = {}
      let newData={}

      for (let m = 0; m < this.tableItems.length; m++) { 
        if(this.tableItems[m].tbody.input)
        {
          if(dataForm[this.tabla]===undefined)
          {
            dataForm[this.tabla]={} 
            dataForm[this.tabla].id=data.id
          }
          for (let i = 0; i < this.tableItems[m].tbody.td.length; i++)
          {
            dataForm[this.tabla][this.tableItems[m].tbody.td[i]]=data[this.tableItems[m].tbody.td[i]]            
          }
        }        
      }

      for (let i = 0; i < inputs.length; i++) {
        splits=inputs[i].split('/')
        if(dataForm[splits[0]]===undefined)
        {
          dataForm[splits[0]]={} 
          dataForm[splits[0]].id=this.dataForm[this.namePath][splits[0]].id
          dataForm[splits[0]]['id_'+this.tabla]=data.id
        }
        dataForm[splits[0]][splits[1]]=this.dataForm[this.namePath][splits[0]][splits[1]]
      }
      await this.updateGlobal({ state: 'indexData', data: this.tableIndex})
      await this.updateDataForm({data: dataForm})	
      this.$emit('save',btn)
    },
    sort(sort,td,index){   
      for(var i=0;i<this.tableItems.length;i++)
      {
        if(index!==i)
        {
          if(this.tableItems[i].thead.sort!==undefined)
          {
            this.tableItems[i].thead.sort=null
          }          
        }        
      }
      this.currentSort=td  
      this.currentSortDir = 'desc'
      if(sort===null || sort===false)
      {
        this.currentSortDir = 'asc'
        return true
      }
      return !sort
    },
    sortedTable(){
       let vm = this;  
         
        let dataFilter = this.deepCopyTable(this.dataGet[this.namePath].data[this.tableIndex][this.tabla]).filter(list => {

        return this.tableSearch.find( items => {
            return cleanParameter(list[items]).indexOf(cleanParameter(this.currentSearch)) > -1
          })         
        })     
        return dataFilter.sort((a,b) => {
          let modifier = 1;
          if(this.currentSortDir === 'desc') modifier = -1;
          if(a[this.currentSort] < b[this.currentSort]) return -1 * modifier
          if(a[this.currentSort] > b[this.currentSort]) return  1 * modifier
          return 0
        });      
    },  
    inputData(data)
    {
      let table=data.split('/')[0]
      let campo=data.split('/')[1]
      return {table: table ,campo: campo }
    }
  }
}
</script>
<style>
.sw-table-dark > thead tr th, .sw-table-dark > thead tr th:hover 
{
  background: #525173 !important;
  color: white !important;
  border: 1px solid #ccc
}
.paginatable .page-link{
  color: #525173 ;
}
.paginatable .active .page-link{
  background: #525173 ;
  border-color:#525173;
}
.paginatable .page-link{
  border-top: none;
}
.paginatable .page-link:focus{
    box-shadow: none;
}
.paginatable .page-item span:first-child{
  border-top-left-radius:0 !important;
}
.paginatable .page-item:last-child .page-link{
  border-top-right-radius:0 !important;
}
.tabletableinput input{
  margin-bottom:0
}
.tabletableinput td{
  padding-top: 7px;
  background: rgba(0, 0, 0, 0.035)
}
.tabletableinput .multiselect{
  margin-bottom: 5px;
}
</style>